export default __webpack_public_path__ + "static/qr-office-2x-mobile-1a0b8fd619cb20980a002b260da16cba.png";